module.exports = __webpack_public_path__ + "img/glasses.083220c9.svg";